export default "__VITE_ASSET__Dnc_xMrw__"